<template>
    <div v-if="isVisible" class="modal-overlay" style="display: flex; justify-content: center; align-items: center; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.5);">
      <div class="modal-content" style="display: flex; flex-direction: column; width: 623px; padding-bottom: 26px; background: white; border-radius: 8px;">
        <!-- Modal Header -->
        <div style="display: flex; justify-content: space-between; align-items: center;">
            <button type="button" class="btn-close" @click="$emit('cancel')" style="background: none; border: none; font-size: 20px;margin-left: auto;"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M11.1879 10.0096L15.5988 5.59876C15.6783 5.52188 15.7418 5.42993 15.7855 5.32826C15.8292 5.22659 15.8522 5.11724 15.8531 5.00659C15.8541 4.89594 15.833 4.78621 15.7911 4.68379C15.7492 4.58138 15.6873 4.48834 15.6091 4.41009C15.5308 4.33185 15.4378 4.26997 15.3354 4.22807C15.233 4.18617 15.1232 4.16509 15.0126 4.16605C14.9019 4.16701 14.7926 4.19 14.6909 4.23367C14.5892 4.27735 14.4973 4.34083 14.4204 4.42042L10.0096 8.83126L5.59876 4.42042C5.44159 4.26862 5.23109 4.18463 5.01259 4.18653C4.79409 4.18843 4.58508 4.27607 4.43057 4.43057C4.27607 4.58508 4.18843 4.79409 4.18653 5.01259C4.18463 5.23109 4.26862 5.44159 4.42042 5.59876L8.83126 10.0096L4.42042 14.4204C4.34083 14.4973 4.27735 14.5892 4.23367 14.6909C4.19 14.7926 4.16701 14.9019 4.16605 15.0126C4.16509 15.1232 4.18617 15.233 4.22807 15.3354C4.26997 15.4378 4.33185 15.5308 4.41009 15.6091C4.48834 15.6873 4.58138 15.7492 4.68379 15.7911C4.78621 15.833 4.89594 15.8541 5.00659 15.8531C5.11724 15.8522 5.22659 15.8292 5.32826 15.7855C5.42993 15.7418 5.52188 15.6783 5.59876 15.5988L10.0096 11.1879L14.4204 15.5988C14.5776 15.7506 14.7881 15.8345 15.0066 15.8327C15.2251 15.8308 15.4341 15.7431 15.5886 15.5886C15.7431 15.4341 15.8308 15.2251 15.8327 15.0066C15.8346 14.7881 15.7506 14.5776 15.5988 14.4204L11.1879 10.0096Z" fill="#9CA3AF"/>
            </svg>
          </button>        </div>
        <div class="p-4 flex flex-col items-center gap-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
            <path d="M21 3.5C17.5388 3.5 14.1554 4.52636 11.2775 6.44928C8.39967 8.37221 6.15665 11.1053 4.83212 14.303C3.50758 17.5007 3.16102 21.0194 3.83627 24.4141C4.51151 27.8087 6.17822 30.9269 8.62564 33.3744C11.0731 35.8218 14.1913 37.4885 17.5859 38.1637C20.9806 38.839 24.4993 38.4924 27.697 37.1679C30.8947 35.8433 33.6278 33.6003 35.5507 30.7225C37.4736 27.8446 38.5 24.4612 38.5 21C38.4949 16.3603 36.6495 11.912 33.3687 8.63126C30.088 5.35048 25.6397 3.5051 21 3.5ZM21 29.75C20.6539 29.75 20.3155 29.6474 20.0278 29.4551C19.74 29.2628 19.5157 28.9895 19.3832 28.6697C19.2508 28.3499 19.2161 27.9981 19.2836 27.6586C19.3512 27.3191 19.5178 27.0073 19.7626 26.7626C20.0073 26.5178 20.3191 26.3511 20.6586 26.2836C20.9981 26.2161 21.3499 26.2508 21.6697 26.3832C21.9895 26.5157 22.2628 26.74 22.4551 27.0277C22.6474 27.3155 22.75 27.6539 22.75 28C22.75 28.4641 22.5656 28.9092 22.2374 29.2374C21.9093 29.5656 21.4641 29.75 21 29.75ZM22.75 22.75C22.75 23.2141 22.5656 23.6592 22.2374 23.9874C21.9093 24.3156 21.4641 24.5 21 24.5C20.5359 24.5 20.0908 24.3156 19.7626 23.9874C19.4344 23.6592 19.25 23.2141 19.25 22.75V14C19.25 13.5359 19.4344 13.0907 19.7626 12.7626C20.0908 12.4344 20.5359 12.25 21 12.25C21.4641 12.25 21.9093 12.4344 22.2374 12.7626C22.5656 13.0907 22.75 13.5359 22.75 14V22.75Z" fill="#FF4265"/>
          </svg>
          <h3 class="pt-3 text-base font-semibold text-custom_gray">¿Estás seguro de cancelar tu suscripción?</h3>
          <p class="text-base font-normal text-custom_gray mt-3">Al confirmar, tu suscripción actual permanecerá activa hasta el final del periodo de facturación. Después de esa fecha, tus beneficios asociados a la suscripción se desactivarán y no se realizarán más cargos.</p>
        </div>
        <div class="modal-footer flex justify-center items-center gap-2 p-4">
          <button @click="$emit('cancel')" class="px-4 py-2 rounded-lg bg-white text-black border">
            Cancelar
          </button>
          <button @click="$emit('confirm')" class="px-4 py-2 rounded-lg bg-tuin_base-0 hover:bg-tuin_hover text-white">
            Confirmar cancelación
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      isVisible: {
        type: Boolean,
        required: true
      }
    }
  }
  </script>
  
  <style>
    .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    }

    .modal-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    width: 300px;
    }

    .modal-actions {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    }

    .modal-actions .btn {
    padding: 8px 16px;
    }

    /* Estilos del modal */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background: white;
    border-radius: 8px;
    width: 400px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    overflow: hidden;
  }
  

  
  </style>

  